import { z } from "zod";

export const insuranceFormSchema = z.object({
  payorOrganizationId: z.string().min(1, "Insurance carrier is required"),
  planCode: z.string().optional(),
  memberId: z.string().min(1, "Member ID is required"),
  groupNumber: z.string().optional(),
  customerServicePhoneNumber: z
    .string()
    .min(10, "Phone number is required")
    .max(16, "Phone number must be less than 16 characters"),
  subscriberRelationship: z
    .enum(["self", "spouse", "child", "other", "parent", "common", "injured"])
    .optional(),
});
